.toast {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  width: min(380px, calc(100vw - var(--space-8)));
  padding: var(--space-3) var(--space-4);
  border: var(--border-width) solid var(--color-border);
  border-radius: var(--radius-lg);
  background: var(--color-surface-raised);
  color: var(--color-text);
  box-shadow: var(--shadow-lg);
  font-family: var(--font-ui);
  font-size: var(--text-md);
}

.title {
  font-weight: var(--weight-medium);
  line-height: var(--leading-snug);
}

.description {
  color: var(--color-text-muted);
  font-size: var(--text-sm);
}

.icon {
  flex: none;
}

.success .icon {
  color: var(--color-success);
}

.error .icon {
  color: var(--color-danger-text);
}

.action {
  margin-left: auto;
  padding: var(--space-1-5) var(--space-3);
  border: none;
  border-radius: var(--radius-sm);
  background: var(--color-surface-hover);
  color: var(--color-text);
  font-weight: var(--weight-medium);
}
